import { render, staticRenderFns } from "./JcdcError404.vue?vue&type=template&id=689200e1&scoped=true"
import script from "./JcdcError404.vue?vue&type=script&lang=ts"
export * from "./JcdcError404.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689200e1",
  null
  
)

export default component.exports